function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { getKey, getRefName, getNormalizeContent } from './utils';
import SubMixin from './mixins/sub';
import ExpanderMixin from './mixins/expander';
export default {
  name: 'TableHeader',
  mixins: [SubMixin, ExpanderMixin],
  computed: {
    rows: function () {
      var fixed = this.fixed,
          headerRows = this.headerRows,
          leftHeaderRows = this.leftHeaderRows,
          rightHeaderRows = this.rightHeaderRows;
      var rows = headerRows;

      if (fixed === 'left') {
        rows = leftHeaderRows;
      } else if (fixed === 'right') {
        rows = rightHeaderRows;
      }

      return rows;
    },
    theadRefName: function theadRefName() {
      return getRefName(this.fixed, 'tableTheadRef');
    },
    headRowStyle: function headRowStyle() {
      var fixed = this.fixed,
          fixedTableHeight = this.fixedTableHeight,
          rows = this.rows;
      var thead = fixedTableHeight.thead;
      var style = {};

      if (thead) {
        style.height = thead === 'auto' ? 'auto' : "".concat(thead / rows.length, "px");
      }

      return fixed ? style : null;
    },
    tableWrapEl: function tableWrapEl() {
      return this.rootVM.$refs.tableWrapRef;
    },
    resizeLineEl: function resizeLineEl() {
      return this.rootVM.$refs.resizeLineRef;
    }
  },
  mounted: function mounted() {
    var $refs = this.$refs,
        theadRefName = this.theadRefName;
    this.saveRef(theadRefName, $refs[theadRefName]);
  },
  methods: {
    renderRow: function renderRow(row, rowIdx) {
      var h = this.$createElement;
      var renderCells = this.renderCells,
          onHeaderRow = this.onHeaderRow,
          headRowStyle = this.headRowStyle;
      var rowProps = {};

      if (isFunction(onHeaderRow)) {
        rowProps = _objectSpread({}, rowProps, {}, onHeaderRow(row.map(function (v) {
          return v.column;
        }), rowIdx));
      }

      var _rowProps = rowProps,
          className = _rowProps.className,
          style = _rowProps.style,
          otherProps = _objectWithoutProperties(_rowProps, ["className", "style"]);

      return h("tr", {
        "class": className,
        "style": [style, headRowStyle],
        "attrs": _objectSpread({}, otherProps)
      }, [renderCells(row, rowIdx)]);
    },
    renderRows: function renderRows() {
      var rows = this.rows,
          renderRow = this.renderRow,
          expandIconAsCell = this.expandIconAsCell,
          fixed = this.fixed,
          renderHeaderExpandIconCell = this.renderHeaderExpandIconCell;

      var datas = _toConsumableArray(rows);

      if (fixed !== 'right' && expandIconAsCell && datas[0]) {
        var row = _toConsumableArray(datas[0]);

        row.unshift(renderHeaderExpandIconCell(datas.length));
        datas[0] = row;
      }

      return datas.map(renderRow);
    },
    getCellProps: function getCellProps(cell, rowIdx, colIdx) {
      var h = this.$createElement;

      var column = cell.column,
          otherProps = _objectWithoutProperties(cell, ["column"]);

      var onHeaderCell = column.onHeaderCell;

      var p = _objectSpread({}, otherProps);

      if (column.align) {
        p.style = {
          textAlign: column.align
        };
      }

      if (typeof onHeaderCell === 'function') {
        p = _objectSpread({}, p, {}, onHeaderCell(column, rowIdx, colIdx));
      } // 只有最底层单元格才允许拖拽改变列宽


      if (column.resizable && (!column.children || column.children.length === 0)) {
        var onResizerMouseDown = this.onResizerMouseDown,
            prefixCls = this.prefixCls;
        var _p = p,
            className = _p.className;
        p.className = className ? [className, "".concat(prefixCls, "-resizable-th")] : "".concat(prefixCls, "-resizable-th");
        var resizeHandler = h("div", {
          "class": "".concat(prefixCls, "-th-resizer"),
          "on": _objectSpread({}, {
            mousedown: function mousedown(event) {
              // 有些列没有key字段，依赖上层table组件设置$$_key
              onResizerMouseDown(column.key || column.$$_key, event);
            }
          })
        });

        if (Array.isArray(p.title)) {
          p.title.push(resizeHandler);
        } else {
          p.title = [p.title, resizeHandler];
        }
      }

      delete p.key;
      return p;
    },
    renderCell: function renderCell(cell, rowIdx, colIdx) {
      var h = this.$createElement;
      var $createElement = this.$createElement,
          getCellProps = this.getCellProps,
          fixed = this.fixed;

      var _getCellProps = getCellProps(cell, rowIdx, colIdx),
          className = _getCellProps.className,
          style = _getCellProps.style,
          on = _getCellProps.on,
          title = _getCellProps.title,
          cellProps = _objectWithoutProperties(_getCellProps, ["className", "style", "on", "title"]);

      var column = cell.column;
      var _cellProps$colspan = cellProps.colspan,
          colspan = _cellProps$colspan === void 0 ? 1 : _cellProps$colspan;

      if (colspan === 0) {
        return null;
      } // 解决使用JSX或$createElement,生成 title时,由于table和fixed table共用VNode,导致不渲染的问题,
      // VNodes must be unique.(https://vuejs.org/v2/guide/render-function.html#Constraints)


      var normalizeTitle = getNormalizeContent($createElement, column.$$_fixed, fixed, title);
      return h("th", {
        "class": className,
        "style": style,
        "attrs": _objectSpread({}, cellProps),
        "on": _objectSpread({}, on),
        "key": getKey(cell.column, colIdx)
      }, [normalizeTitle]);
    },
    renderCells: function renderCells() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var rowIdx = arguments.length > 1 ? arguments[1] : undefined;
      var renderCell = this.renderCell;
      return row.map(function (cell, i) {
        return renderCell(cell, rowIdx, i);
      });
    },
    onResizerMouseDown: function onResizerMouseDown(key, e) {
      e.preventDefault();
      var target = e.target,
          clientX = e.clientX;
      var th = target.parentNode;
      var minResizeColWidth = this.minResizeColWidth,
          tableWrapEl = this.tableWrapEl,
          resizeLineEl = this.resizeLineEl,
          rootVM = this.rootVM;

      var _tableWrapEl$getBound = tableWrapEl.getBoundingClientRect(),
          tableLeft = _tableWrapEl$getBound.left,
          tableWidth = _tableWrapEl$getBound.width;

      var _th$getBoundingClient = th.getBoundingClientRect(),
          thLeft = _th$getBoundingClient.left,
          thWidth = _th$getBoundingClient.width;

      var offset = thLeft - tableLeft;
      var originLeft = offset + thWidth;
      var left = originLeft;
      resizeLineEl.style.left = "".concat(originLeft, "px");
      rootVM.$emit('toggle-resize-line-visible', true);

      var onMouseMove = function (_ref) {
        var currentX = _ref.clientX;
        left = Math.max(Math.min(tableWidth - 1, originLeft + (currentX - clientX)), offset + minResizeColWidth);
        resizeLineEl.style.left = "".concat(left, "px");
      };

      var onMouseUp = function (evt) {
        var delta = left - originLeft;
        rootVM.$emit('toggle-resize-line-visible', false);
        rootVM.$emit('resize-column-width', evt, thWidth + delta, thWidth, key);
        document.removeEventListener('mousemove', onMouseMove, false);
        document.removeEventListener('mouseup', onMouseUp, false);
      };

      document.addEventListener('mousemove', onMouseMove, false);
      document.addEventListener('mouseup', onMouseUp, false);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        renderRows = this.renderRows,
        theadRefName = this.theadRefName;
    return h("thead", {
      "ref": theadRefName,
      "class": "".concat(prefixCls, "-thead")
    }, [renderRows()]);
  }
};